import { render, staticRenderFns } from "./ClassTrainingStatistics.vue?vue&type=template&id=4210226f&scoped=true"
import script from "./ClassTrainingStatistics.vue?vue&type=script&lang=js"
export * from "./ClassTrainingStatistics.vue?vue&type=script&lang=js"
import style0 from "./ClassTrainingStatistics.vue?vue&type=style&index=0&id=4210226f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210226f",
  null
  
)

export default component.exports